/* HEARTBOOK add-ons block. Source: HQ-Groups brands/heartbook/store/addons-2026-09-25/
   Adds one item with /cart/add.js, refreshes the Shrine cart drawer + cart icon without opening the drawer.
   27/09 audit C7: nạp async, định nghĩa khi HTML dựng xong (không chờ main.js), như hb-sticky-buy.js. */
const hbDefineAddons = () => {
if (!customElements.get('hb-addons')) {
  customElements.define(
    'hb-addons',
    class HbAddons extends HTMLElement {
      connectedCallback() {
        this.status = this.querySelector('[data-hb-addons-status]');
        this.querySelectorAll('.hb-addon').forEach((card) => this.bindCard(card));
      }

      bindCard(card) {
        const add = card.querySelector('.hb-addon__add');
        card.querySelectorAll('.hb-sw').forEach((sw) => {
          sw.addEventListener('click', () => {
            card.querySelectorAll('.hb-sw').forEach((o) => o.setAttribute('aria-pressed', o === sw ? 'true' : 'false'));
            this.applyVariant(card, sw.dataset);
          });
        });
        const select = card.querySelector('.hb-addon__select');
        if (select) {
          select.addEventListener('change', () => this.applyVariant(card, select.selectedOptions[0].dataset, select.value));
        }
        if (add) add.addEventListener('click', () => this.addToCart(add));
      }

      applyVariant(card, data, id) {
        const add = card.querySelector('.hb-addon__add');
        add.dataset.variantId = id || data.variantId;
        if (data.sellingPlan) add.dataset.sellingPlan = data.sellingPlan;
        else delete add.dataset.sellingPlan;

        const img = card.querySelector('.hb-addon__img');
        if (img && data.src) {
          img.srcset = data.srcset || '';
          img.src = data.src;
          img.alt = data.title || img.alt;
        }
        const style = card.querySelector('.hb-addon__style');
        if (style && data.title) style.textContent = data.title;
        // ghi chú chờ hàng theo mẫu vừa chọn (tự tính trong Liquid, rỗng = còn hàng)
        const note = card.querySelector('.hb-addon__note');
        if (note && 'note' in data) {
          note.textContent = data.note || '';
          note.hidden = !data.note;
        }
        const now = card.querySelector('.hb-addon__now');
        if (now && data.price) now.textContent = data.price;
        const was = card.querySelector('.hb-addon__was');
        if (was) {
          was.textContent = data.compare || '';
          was.hidden = !data.compare;
        }
      }

      setState(btn, state, text) {
        const label = btn.querySelector('.hb-addon__label');
        btn.dataset.state = state;
        label.textContent = text || label.dataset.default;
      }

      sectionIds() {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          return drawer.getSectionsToRender().map((s) => s.id);
        }
        return ['cart-icon-bubble'];
      }

      async addToCart(btn) {
        if (btn.dataset.state === 'loading') return;
        clearTimeout(btn._hbReset);
        this.setState(btn, 'loading', this.dataset.addingLabel);

        const body = {
          id: Number(btn.dataset.variantId),
          quantity: 1,
          sections: this.sectionIds(),
          sections_url: window.location.pathname,
        };
        if (btn.dataset.sellingPlan) body.selling_plan = Number(btn.dataset.sellingPlan);

        const root = (window.routes && window.routes.cart_add_url) || '/cart/add';
        try {
          const res = await fetch(`${root}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart error');

          // 26/09 (founder: bấm Quick add xong giỏ hiện giao diện trang /cart): PHÁT tín hiệu cartUpdate TRƯỚC rồi mới vẽ ngăn giỏ, đúng thứ tự nút mua Shrine.
          // Vẽ trước thì danh sách hàng MỚI của ngăn giỏ nhận tín hiệu, tải /cart?section_id=main-cart-items (HTML trang giỏ) và ghi đè lên ngăn giỏ.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-addons', productVariantId: body.id, cartData: data });
          }
          this.renderCart(data);
          this.setState(btn, 'added', this.dataset.addedLabel);
          if (this.status) this.status.textContent = `${data.product_title || 'Item'} added to cart`;
        } catch (err) {
          console.error('[hb-addons]', err);
          this.setState(btn, 'error', this.dataset.errorLabel);
          if (this.status) this.status.textContent = err.message;
        }
        btn._hbReset = setTimeout(() => this.setState(btn, ''), 2400);
      }

      renderCart(data) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data, true);
          return;
        }
        const bubbleHtml = data.sections && data.sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) {
          const fresh = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        }
      }
    }
  );
}
};
// định nghĩa khi HTML đã dựng xong (readyState 'interactive' đến TRƯỚC các script defer), để thẻ con của khối đã có
if (document.readyState === 'loading') {
  document.addEventListener('readystatechange', function hbAddonsReady() {
    if (document.readyState === 'loading') return;
    document.removeEventListener('readystatechange', hbAddonsReady);
    hbDefineAddons();
  });
} else {
  hbDefineAddons();
}
